import { Component, input } from '@angular/core';

import { DetailsValueComponent } from '@iw/common';
import { CardNumberPipe } from '@iw/core/pipes';

import { CardPersonal, WithdrawalReq } from '../../../entities';

@Component({
  selector: 'iw-card-personal-details',
  imports: [DetailsValueComponent, CardNumberPipe],
  templateUrl: './card-personal-details.component.html',
  styleUrl: './card-personal-details.component.scss',
})
export class CardPersonalDetailsComponent {
  withdrawalInfo = input.required<WithdrawalReq>();

  get details(): CardPersonal {
    return this.withdrawalInfo().details as CardPersonal;
  }
}
